import { useMutateEntry, makeInitialOpgavekompleksetTaskEntry, canValidateOpgavekompleksetTask } from '@utils/component-framework';
import { useOpgavekompleksetComponent } from '../context.data.js';
import { selectCurrentTaskEntryId } from '../hook.entry.js';
import { updateStats } from './util.update-stats.js';

function useFinishEntryMutation() {
  const {
    entryKey,
    data
  } = useOpgavekompleksetComponent();
  const mutater = useMutateEntry(entryKey);
  return options => mutater(entry => {
    //
    // STEP: Ensure that the current task is marked as skipped, if configured.
    //
    const activeTaskId = selectCurrentTaskEntryId(data, entry.data);
    if (activeTaskId) {
      const currentTask = entry.data.tasks[activeTaskId] ??= makeInitialOpgavekompleksetTaskEntry(data, activeTaskId);
      currentTask.state.skipped = options?.markCurrentTaskAsSkipped ?? false;
    }

    //
    // STEP: All tasks that have been interacted with, but not
    // validated/finsihed should be so once the entry is completed, in case
    // they have not been explictly skipped.
    //
    for (const taskEntry of Object.values(entry.data.tasks)) {
      const task = data.tasks.find(it => it.id === taskEntry.id);
      if (!task) {
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete entry.data.tasks[taskEntry.id];
        continue;
      }
      const canValidate = canValidateOpgavekompleksetTask(task);
      const hasInteracted = canValidate ? Object.keys(taskEntry?.details ?? {}).length > 0 : taskEntry?.state.closed;
      if (canValidate && hasInteracted && !taskEntry.state.skipped && !taskEntry.state.validated) {
        taskEntry.state.validated = true;
        taskEntry.state.attempts++;
        updateStats(entry, data, taskEntry.id);
      } else if (canValidate && taskEntry.state.attempts === 0) {
        taskEntry.state.skipped = true;
      }
    }

    //
    // STEP: Update global entry metadata
    //
    entry.data.endTime = Date.now();
    entry.envelope.result ??= {
      status: "completed"
    };
    entry.envelope.result.status = "completed";
    entry.envelope.result.time = Math.round((entry.data.endTime - entry.data.startTime) / 1000);
    entry.envelope.result.score = Object.values(entry.data.tasks).reduce((acc, curr) => ({
      pointsGotten: acc.pointsGotten + curr.stats.correct,
      pointsTotal: acc.pointsTotal + curr.stats.total
    }), {
      pointsTotal: 0,
      pointsGotten: 0
    });
    entry.envelope.readOnly = true;
    return entry;
  });
}

export { useFinishEntryMutation };
//# sourceMappingURL=finish.js.map
